import React from 'react';
import Common_recharge_page_banner from '../../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';

import Success_Lottie from '../../../../animations/success_lottie/Success_Lottie';
import Proceed_btn from '../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Electricity_recharge_plan_card_holder from '../../../../common_components/common_cards/service_rechage_cards/electricity_Recharge_cards/electricity_recharge_plan_card_holder/Electricity_recharge_plan_card_holder';
import Mobile_prepaid_plan_card_holder from '../../../../common_components/common_cards/service_rechage_cards/mobile_Recharge_cards/mobile_prepaid_plan_card_holder/Mobile_prepaid_plan_card_holder';
import Successfull_Modal from '../../../../common_components/common_modal/successfull_modal/Successfull_Modal';
import Contribution from '../../../../home/contribution/Contribution';

function Electricity_recharge_details() {
    const [modalShow, setModalShow] = React.useState(false);
    const breadcrumbData = [
        { label: "Services", path: "/services" },
        { label: "Electricity Bill", path: "/electricity-recharge" },
        { label: "Andhra Pradesh Central Power Distribution ..." },

    ];
    return (
        <>
            <section className='Mobile_recharge_view_plans Dth_recharge_details'>
                <Common_recharge_page_banner
                    title="ELECTRICITY BILL"
                    breadcrumbItems={breadcrumbData}
                />

                {/* Left Side - Form */}
                <div className="Mobile_Recharge">
                    <div className="container">
                        <div className="recharge_form_section form_box_section">
                            <div className="row justify-content-center">
                                <div className="col-md-8 col-12">
                                    <Mobile_prepaid_plan_card_holder planName={"Andhra Pradesh Central Power Distribution ..."} changeLink={"/electricity-recharge"} number={"8864732301"} />

                                    <div className="select_plan_hodler">
                                        <div className="heading_text">
                                            <h6>Details</h6>
                                        </div>

                                        <Electricity_recharge_plan_card_holder />
                                    </div>

                                    <div className="btn_holder ">
                                        <Proceed_btn
                                            btnText="Proceed To Pay"
                                            className="save_changes_btn"
                                            onClick={() => setModalShow(true)}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Contribution />

            </section>
            <Successfull_Modal
                show={modalShow}
                message="Electricity Bill Paid!"
                subMessage="Your electricity bill payment is complete. Payment received, & your plan is now active"
                onHide={() => setModalShow(false)}
                lottie={<Success_Lottie />}
            />
        </>
    )
}

export default Electricity_recharge_details